import type { DbmsPlugin, DbmsPluginInstallArgs } from '../relate.types';
import type { Builder } from './types';

export const pluginEndpoints = (builder: Builder) => ({
  listAvailablePlugins: builder.query<DbmsPlugin[], string>({
    query: (id) => ({ url: 'list-available-dbms-plugins', params: { dbmsId: id } }),
  }),

  listInstalledPlugins: builder.query<DbmsPlugin[], string>({
    query: (id) => ({ url: 'list-installed-dbms-plugins', params: { dbmsId: id } }),
    providesTags: (_res, _err, dbmsId) => [{ type: 'DbmsPlugins', id: dbmsId }],
  }),

  installPlugin: builder.mutation<string, DbmsPluginInstallArgs>({
    query: (args) => ({
      url: 'install-dbms-plugin',
      method: 'POST',
      body: args,
    }),
    invalidatesTags: (_res, _err, { dbmsId }) => [{ type: 'DbmsPlugins', id: dbmsId }],
  }),

  uninstallPlugin: builder.mutation<string, DbmsPluginInstallArgs>({
    query: (args) => ({
      url: 'uninstall-dbms-plugin',
      method: 'POST',
      body: args,
    }),
    invalidatesTags: (_res, _err, { dbmsId }) => [{ type: 'DbmsPlugins', id: dbmsId }],
  }),
});
